"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputRelation = _interopRequireDefault(require("../InputRelation"));
var _InputString = _interopRequireDefault(require("../InputString"));
var _InputPassword = _interopRequireDefault(require("../InputPassword"));
var _InputNumber = _interopRequireDefault(require("../InputNumber"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _InputJson = _interopRequireDefault(require("../InputJson"));
var _InputImage = _interopRequireDefault(require("../InputImage"));
var _InputFile = _interopRequireDefault(require("../InputFile"));
var _InputSignature = _interopRequireDefault(require("../InputSignature"));
var _InputPointer = _interopRequireDefault(require("../InputPointer"));
var _InputSelect = _interopRequireDefault(require("../InputSelect"));
var _InputIcon = _interopRequireDefault(require("../InputIcon"));
var _RelatedFactory = _interopRequireDefault(require("../RelatedFactory"));
var _InputBoolean = _interopRequireDefault(require("../InputBoolean"));
var _Input = _interopRequireDefault(require("../Input"));
var _getPropertyByPath = _interopRequireDefault(require("../getPropertyByPath"));
var _setObjectByPath = _interopRequireDefault(require("../setObjectByPath"));
var _excluded = ["type", "_type", "field", "object", "schemas", "onChange", "required", "onProps"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputFactory/index.js";
var defaultProps = {
  schemas: []
};
function InputFactory(_ref) {
  var type = _ref.type,
    _type = _ref._type,
    field = _ref.field,
    object = _ref.object,
    schemas = _ref.schemas,
    onChange = _ref.onChange,
    required = _ref.required,
    onProps = _ref.onProps,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var reference = props.reference && (0, _getPropertyByPath["default"])(object, props.reference);
  var value = reference || object && object[field];
  if (typeof onProps === "function") {
    props = onProps(props, object, field) || props;
  }
  var _onChange = function _onChange(field, value) {
    if (object) {
      (0, _setObjectByPath["default"])(object, props.reference || field, value);
      if (props.reference) {
        var change = {};
        field = (0, _setObjectByPath["default"])(change, props.reference, value);
        value = change[field];
      }
    }
    onChange(value, field);
  };
  type = _type || type;
  switch (type) {
    case 'Email':
    case 'String':
      return /*#__PURE__*/_react["default"].createElement(_InputString["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        type: type.toLowerCase(),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 20
        }
      }));
    case 'Password':
    case 'InputPassword':
      return /*#__PURE__*/_react["default"].createElement(_InputPassword["default"], Object.assign({
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 20
        }
      }));
    case 'Number':
    case 'Tel':
      return /*#__PURE__*/_react["default"].createElement(_InputNumber["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59,
          columnNumber: 20
        }
      }));
    case 'Text':
    case 'InputText':
      return /*#__PURE__*/_react["default"].createElement(_InputText["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66,
          columnNumber: 20
        }
      }));
    case 'Relation':
      return /*#__PURE__*/_react["default"].createElement(_InputRelation["default"], Object.assign({
        field: field,
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 20
        }
      }));
    case 'Pointer':
      var schema = props.schema || schemas.find(function (s) {
        return s.collection === props.target;
      });
      if (!schema) return null;
      return /*#__PURE__*/_react["default"].createElement(_InputPointer["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 20
        }
      }));
    case 'Related':
    case 'InputRelated':
      return /*#__PURE__*/_react["default"].createElement(_RelatedFactory["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        schema: props.schema || schemas.find(function (s) {
          return s.collection === props.target;
        }),
        schemas: schemas,
        field: field,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 20
        }
      }));
    case 'Image':
    case 'InputImage':
      return /*#__PURE__*/_react["default"].createElement(_InputImage["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 20
        }
      }));
    case 'File':
    case 'InputFile':
      return /*#__PURE__*/_react["default"].createElement(_InputFile["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 109,
          columnNumber: 20
        }
      }));
    case 'InputSignature':
    case 'Signature':
      return /*#__PURE__*/_react["default"].createElement(_InputSignature["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116,
          columnNumber: 20
        }
      }));
    case 'Boolean':
      return /*#__PURE__*/_react["default"].createElement(_InputBoolean["default"], Object.assign({
        value: value,
        onChange: _onChange.bind(this, field),
        field: field,
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 20
        }
      }));
    case 'Object':
    case 'Array':
      return /*#__PURE__*/_react["default"].createElement(_InputJson["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130,
          columnNumber: 20
        }
      }));
    case 'Enum':
    case 'InputSelect':
      return /*#__PURE__*/_react["default"].createElement(_InputSelect["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        placeholder: props.placeholder || (props.dynamic ? "Select of type " : "Select ") + (props.label || field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 20
        }
      }));
    case 'Icon':
    case 'InputIcon':
      return /*#__PURE__*/_react["default"].createElement(_InputIcon["default"], Object.assign({
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145,
          columnNumber: 20
        }
      }));
    case 'Date':
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        type: type.toLowerCase(),
        defaultValue: value && value.slice(0, 10),
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 20
        }
      }));
    case 'Color':
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        className: "form-control-color",
        type: type.toLowerCase(),
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 20
        }
      }));
    default:
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], Object.assign({
        type: type.toLowerCase(),
        defaultValue: value,
        onChange: _onChange.bind(this, field),
        required: required
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 20
        }
      }));
  }
}
InputFactory.defaultProps = defaultProps;
var _default = InputFactory;
exports["default"] = _default;